/* eslint-disable no-unused-vars */
import React from 'react';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { MenuItem } from 'components';
import { ArrowRightDirection } from 'assets/icons';

const isSelected = (filterValue, currentFilter$) => {
  return currentFilter$.value === filterValue;
};

export const LeftBlock = ({ placementList$, countryList$, advertiserList$, currentFilter$ }) => {
  return (
    <Box>
      {placementList$.value.size ? (
        <MenuItem
          isSelected={isSelected('placement', currentFilter$)}
          height={40}
          value={'placement'}
          key={'placement'}
          // wrapStyle={{}}
          // style={{ width: '100%' }}
          onClick={(value) => {
            currentFilter$.value = value;
          }}
        >
          <Content>
            Placement {isSelected('placement', currentFilter$) && <ArrowRightDirection />}
          </Content>
        </MenuItem>
      ) : null}
      {countryList$.value.size ? (
        <MenuItem
          isSelected={isSelected('country', currentFilter$)}
          height={40}
          value={'country'}
          key={'country'}
          // wrapStyle={{}}
          // style={{ width: '100%' }}
          onClick={(value) => {
            currentFilter$.value = value;
          }}
        >
          <Content>
            Country {isSelected('country', currentFilter$) && <ArrowRightDirection />}
          </Content>
        </MenuItem>
      ) : null}
      {advertiserList$.value.size ? (
        <MenuItem
          isSelected={isSelected('advertiser', currentFilter$)}
          height={40}
          value={'advertiser'}
          key={'advertiser'}
          onClick={(value) => {
            currentFilter$.value = value;
          }}
        >
          <Content>
            Advertiser {isSelected('advertiser', currentFilter$) && <ArrowRightDirection />}
          </Content>
        </MenuItem>
      ) : null}
    </Box>
  );
};
const Content = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const Box = styled.div`
  padding: 8px;
  width: 136px;
  border-right: 1px solid ${Palette.PrimaryGray._200};
  background: ${Palette.PrimaryGray._000};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`;
